var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#000000",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1920 912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,456) scale(1,1) translate(-960,-456)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur-elllkocjnbe-1",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-elllkocjnbe-2",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-elllkocjnbe-3",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 1298.6143878944226,
    cy: 0,
    transform: "translate(0 455.8364805022117)",
    r: 8.014181231955895,
    fill: "#e7cbfb",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.061300478168951s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 920.014181231956;0 -8.014181231955895"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1345.2655709368169,
    cy: 0,
    transform: "translate(0 466.39907125911105)",
    r: 9.44282317280436,
    fill: "#b2f0ac",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.0449817536528503s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 921.4428231728043;0 -9.44282317280436"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1755.3595410771893,
    cy: 0,
    transform: "translate(0 426.75007055562764)",
    r: 4.458844182464573,
    fill: "#e9beec",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.010320081638263s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 916.4588441824645;0 -4.458844182464573"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1776.0467728875753,
    cy: 0,
    transform: "translate(0 591.5063156663646)",
    r: 14.476098867853185,
    fill: "#e9beec",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-6.36771491268182s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 926.4760988678532;0 -14.476098867853185"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 682.4204554114119,
    cy: 0,
    transform: "translate(0 357.90662919909386)",
    r: 11.13848735331816,
    fill: "#b2f0ac",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.3214863940004098s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 923.1384873533182;0 -11.13848735331816"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1729.506301937,
    cy: 0,
    transform: "translate(0 198.8516160044371)",
    r: 12.809920498120903,
    fill: "#e7cbfb",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.395568567997769s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 924.8099204981208;0 -12.809920498120903"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 543.5934946074781,
    cy: 0,
    transform: "translate(0 583.8347924784447)",
    r: 15.205815069243066,
    fill: "#b2f0ac",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.424691679876825s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 927.205815069243;0 -15.205815069243066"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38.9726872002916,
    cy: 0,
    transform: "translate(0 522.216041343564)",
    r: 15.040148961263741,
    fill: "#e9beec",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.9684928402196873s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 927.0401489612638;0 -15.040148961263741"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 952.6948465460491,
    cy: 0,
    transform: "translate(0 238.59807872973224)",
    r: 5.448589832136447,
    fill: "#e7cbfb",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-16.834232138639514s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 917.4485898321365;0 -5.448589832136447"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 719.1291123023007,
    cy: 0,
    transform: "translate(0 140.02324535832514)",
    r: 7.335503841041687,
    fill: "#b2f0ac",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.298732571049792s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 919.3355038410417;0 -7.335503841041687"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1709.9686866282111,
    cy: 0,
    transform: "translate(0 686.9996958492264)",
    r: 6.255660179989372,
    fill: "#e7cbfb",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-12.580816773996485s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 918.2556601799894;0 -6.255660179989372"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1708.4564316272927,
    cy: 0,
    transform: "translate(0 710.3580498424977)",
    r: 12.256536155669501,
    fill: "#e7cbfb",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.4183710295739393s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 924.2565361556696;0 -12.256536155669501"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.5969322590086,
    cy: 0,
    transform: "translate(0 539.9901979756045)",
    r: 11.61606845718513,
    fill: "#e9beec",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.213038941221729s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 923.6160684571852;0 -11.61606845718513"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.2597114851537,
    cy: 0,
    transform: "translate(0 389.0792903105753)",
    r: 5.018854549124325,
    fill: "#b2f0ac",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-18.742093433147367s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 917.0188545491243;0 -5.018854549124325"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1501.6969600395887,
    cy: 0,
    transform: "translate(0 623.4901148089718)",
    r: 4.165564454708434,
    fill: "#b2f0ac",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-10.153318885882356s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 916.1655644547085;0 -4.165564454708434"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 732.6768669404412,
    cy: 0,
    transform: "translate(0 618.9505297140942)",
    r: 14.926653864704381,
    fill: "#b2f0ac",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.529212952776805s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 926.9266538647043;0 -14.926653864704381"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.8f8211907abe8b7a3140cc2e7a24d8be.svg";
export { ForwardRef as ReactComponent };